export const getStatusColor = (status: string): 'error' | 'success' | 'warning' | 'default' | 'info' | 'primary' => {
  const isActive = ['active', 'success', 'approved', 'scheduled', 'reviewed by ops'].includes(status.toLowerCase());

  if (isActive) {
    return 'success';
  }

  switch (status.toLowerCase()) {
    case 'inactive': {
      return 'info';
    }
    case 'under revision': {
      return 'primary';
    }
    case 'paused': {
      return 'warning';
    }
    default: {
      return 'default';
    }
  }
};
